// HUD 바 번쩍임 리미터(COMBAT-FEEL 5.1, 순수 로직·DOM 없음). 화면(HUD) 하나에 1개를 두고 영웅·보스·대상 체력 바가 함께 쓴다.
// 기준은 FLASH_SAFETY(1초 3회 이하, 간격 334ms 이상, 1회 100ms 이하). 시각은 렌더 벽시계(ms)이고, 이벤트 신선도만 게임 틱으로 본다.
// 한 update에서 모은 요청은 많아야 1회로 합치고, 거절한 요청은 버린다(대기열 없음). 생성 뒤 할당하지 않는다.
import { FLASH_SAFETY } from '../shared/config';

/** 바 비트. 값이 작을수록 우선한다 */
export const HUD_BAR_HERO = 1;
export const HUD_BAR_BOSS = 2;
export const HUD_BAR_TARGET = 4;
/** 이 틱 수보다 오래된 타격·피격 이벤트는 번쩍임을 요청하지 않는다(게임 시간 100ms) */
export const HUD_FLASH_STALE_TICKS = 6;
/** 번쩍임 한 번 길이(ms) */
export const HUD_FLASH_MS = FLASH_SAFETY.maxFlashMs;

export class HudFlashGate {
  /** 최근 승인 시각(최대 maxPerSecond개 고리) */
  private readonly times = new Float64Array(FLASH_SAFETY.maxPerSecond);
  private n = 0;
  private last = -Infinity;
  private pending = 0;
  /** QA: 승인·버림·오래돼서 무시한 수 */
  granted = 0;
  dropped = 0;
  stale = 0;

  /** 이벤트 하나의 번쩍임 요청을 모은다. eventTick·nowTick은 게임 틱 */
  ask(bar: number, eventTick: number, nowTick: number): void {
    if (nowTick - eventTick > HUD_FLASH_STALE_TICKS) { this.stale++; return; }
    this.pending |= bar;
  }

  /**
   * update 끝에 한 번 부른다. 모은 요청 중 지금 보이는 바(visible 비트) 하나를 골라 리미터가 허락하면 그 비트를, 아니면 0을 돌려준다.
   * 모은 요청은 결과와 상관없이 비운다. allowed=false(각성 연출 중)면 리미터를 쓰지 않고 버린다.
   */
  take(nowMs: number, visible: number, allowed: boolean): number {
    const w = this.pending & visible;
    this.pending = 0;
    if (w === 0) return 0;
    if (!allowed || !this.request(nowMs)) { this.dropped++; return 0; }
    return w & HUD_BAR_HERO ? HUD_BAR_HERO : w & HUD_BAR_BOSS ? HUD_BAR_BOSS : HUD_BAR_TARGET;
  }

  /** 모은 요청을 버린다(장면 전환·결과 화면) */
  clear(): void {
    this.pending = 0;
  }

  private request(nowMs: number): boolean {
    if (nowMs - this.last < FLASH_SAFETY.minGapMs) return false;
    const len = this.times.length;
    // 고리에서 덮어쓸 칸이 최근 len개 중 가장 오래된 승인이다
    if (this.n >= len && nowMs - this.times[this.n % len] < 1000) return false;
    this.times[this.n % len] = nowMs;
    this.n++;
    this.last = nowMs;
    this.granted++;
    return true;
  }
}
